<template>
  <div>
      <QuestionWrapper>
          <QuestionTitle>
            Welcome! Let's get started.
          </QuestionTitle>
          <ChoicesWrapper>
            <Choice @click="handleTrial()" id="trial-select">
              <ChoiceTitle>Try it</ChoiceTitle>
              <ChoiceBlurb>Free 1 Day Pass</ChoiceBlurb>
              <ChoiceContext>See how you like it</ChoiceContext>
            </Choice>
            <Choice @click="handleCustomer()" id="pay-select">
              <ChoiceTitle>Ready</ChoiceTitle>
              <ChoiceBlurb>3 Months Access w/ Unlimited Support</ChoiceBlurb>
              <ChoiceContext>$29 w/ 30 Day Money Back Guarantee</ChoiceContext>
            </Choice>
          </ChoicesWrapper>
      </QuestionWrapper>
  </div>
</template>

<script>
import { getUser } from '../utils/battles-api'
import { isLoggedIn, login } from '../utils/auth'

export default {
  data() {
    return {}
  },
  methods: {
    handleTrial(){
      localStorage.isTry = true;
      localStorage.trialStart = new Date()
      login()
    },
    handleCustomer() {
      localStorage.isTry = false;
      login()
    },
    getUser() {
      getUser().then((user) => {
        // Set user
        this.$store.commit('setUser', user)
        // if user paid, redirect to home
        // payment component also will redirect to home upon successful payment
        if (user.payment && user.payment.duration > 0) {
          // alert("paid")
          this.$router.push({ path: 'home' })
        }
      }).catch((error) => {
        console.log(error)
        //alert("error")
      })
    }
  },
  mounted() {
    this.getUser()
    /*
    if (!this.isLoggedIn()) {
      alert("not logged in")
      this.handleLogin()
    }
    */
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.log {
  margin: 5px 10px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Plan.vue